
  <template>
    <div> 
      <GenericBoard />
    </div>
  </template>
  
  <script>
  import GenericBoard from '@/views/INSIGHT/INSIGHTList.vue'
  
  export default {
    components: {
      GenericBoard
    }, 
  }
  </script>